import type { MessageDefinitions } from '@dsx/react';

import enUS from './common.en-US.json';

const messages: MessageDefinitions<typeof enUS> = {
	'en-US': enUS,
};

export default messages;
